export const SEARCH_DEBOUNCE_MS = 300;
export const RANGE_BATCH_DELAY_MS = 150;
